export default {
  path: '/ai-board',
  name: 'AiBoard',
  component: () => import('@/pages/ai-board/index.vue'),
  children: [
    {
      path: 'chat-assistant',
      name: 'meetingAgent',
      component: () => import('@/pages/ChatAssistant/index.vue'),
      meta: {
        title: '跟进助手'
      }
    },
    {
      path: 'meeting-assessment',
      name: 'meetingAssessment',
      meta: {
        title: '员工会话 PK'
      },
      component: () => import('@/pages/ai-board/meeting-assessment.vue')
    },
    {
      path: 'conversation-quality',
      name: 'conversationQualityReview',
      meta: {
        title: '跟进质量复盘'
      },
      component: () => import('@/pages/ai-board/conversation-quality.vue')
    },
    {
      path: 'clueFollowUpReview',
      name: 'clueFollowUpReview',
      meta: {
        title: '线索跟进复盘'
      },
      component: () => import('@/pages/ai-board/clue-follow-up-review/index.vue')
    },
    {
      path: 'meeting-review',
      name: 'meetingReview',
      meta: {
        title: '客户跟进复盘'
      },
      component: () => import('@/pages/ai-board/meeting-review/index.vue')
    },
    {
      path: 'opportunity-review',
      name: 'opportunityReview',
      meta: {
        title: '商机跟进复盘'
      },
      component: () => import('@/pages/ai-board/opportunity-review/index.vue')
    },
    {
      path: 'use-detail',
      name: 'useDetail',
      meta: {
        inMenu: 'setting',
        pathName: '用量详情'
      },
      component: () => import('@/pages/ai-board/use-detail.vue')
    },
    {
      path: 'permission-management',
      name: 'permissionManagement',
      meta: {
        inMenu: 'setting',
        pathName: '权限管理'
      },
      component: () => import('@/pages/ai-board/permission-management/index.vue')
    },
    {
      path: 'assistant-management',
      name: 'assistantManagement',
      meta: {
        inMenu: 'setting',
        pathName: '助手管理'
      },
      component: () => import('@/pages/ai-board/assistant-management/index.vue')
    },
    {
      path: 'data-source-management',
      name: 'dataSourceManagement',
      meta: {
        inMenu: 'setting',
        pathName: '数据源管理'
      },
      component: () => import('@/pages/ai-board/data-source-management/index.vue')
    },
    {
      path: 'staff-practice-partner-configuration',
      name: 'staffPracticePartnerConfiguration',
      meta: {
        inMenu: 'setting',
        pathName: '公司配置'
      },
      component: () => import('@/pages/ai-board/staff-practice-partner-configuration/index.vue')
    },
    // TODO 已经下架的页面
    {
      path: 'session-set',
      name: 'sessionSet',
      meta: {
        pathName: '跟进分析配置'
      },
      component: () => import('@/pages/ai-board/session-set/index.vue')
    },
    // TODO 已经下架的页面
    {
      path: 'expert-lib',
      name: 'expertLib',
      meta: {
        pathName: '行业专家库'
      },
      component: () => import('@/pages/ai-board/expert-lib/index.vue')
    },
    {
      path: 'customer-rglight',
      name: 'customerRedOrGreenLight',
      meta: {
        pathName: '标杆客户红绿灯'
      },
      component: () => import('@/pages/ai-board/customer-rglight.vue')
    },
    {
      path: 'user-follow-schedule',
      name: 'userFollowSchedule',
      meta: {
        pathName: '员工跟进日常'
      },
      component: () => import('@/pages/ai-board/user-follow-schedule/index.vue')
    },
    {
      path: 'staff-practice-partner-pk',
      name: 'aiSalesBoardPracticePk',
      meta: {
        pathName: '员工陪练 PK'
      },
      component: () => import('@/pages/ai-board/staff-practice-partner-pk/index.vue')
    },
    {
      path: 'topic-analyst',
      name: 'topicAnalyst',
      component: () => import('@/pages/TalkAssistant/index.vue'),
      meta: {
        title: 'Ai分析师',
        type: 'topicAnalyst'
      }
    },
    {
      path: 'clue-assistant',
      name: 'clueAssistant',
      component: () => import('@/pages/ClueFixAssistant/index.vue'),
      meta: {
        title: '线索清洗助手',
        type: 'clueAssistant'
      }
    },
    {
      path: 'ai-find-customer',
      name: 'aiFindCustomerAssistant',
      component: () => import('@/pages/ai-find-customer/index.vue'),
      meta: {
        title: '芝麻找客助手',
        type: 'aiFindCustomerAssistant'
      }
    },
    {
      path: 'ai-bidding',
      name: 'aiBiddingAssistant',
      component: () => import('@/pages/ai-bidding/index.vue'),
      meta: {
        title: '芝麻标讯助手',
        type: 'aiBiddingAssistant'
      }
    },
    {
      path: 'knowledge-base',
      name: 'knowledgeBase',
      component: () => import('@/pages/knowledge/index.vue'),
      meta: {
        title: '知识库'
        // type: 'knowledgeBase'
      }
    },
    {
      path: 'knowledge-content',
      name: 'knowledgeContent',
      component: () => import('@/pages/knowledge/content/index.vue')
    },
    {
      path: 'ai-practice-partner',
      name: 'aiTrainingAssistant',
      component: () => import('@/pages/ai-practice-partner/index.vue'),
      meta: {
        title: 'AI陪练助手'
      }
    },
    {
      path: 'qoder-agent',
      name: 'aiAgent',
      component: () => import('@/pages/qoder-clould-agent/index.vue'),
      meta: {
        title: '销帮帮 AI 助理'
      }
    },
    {
      path: 'extension',
      name: 'extension',
      component: () => import('@/pages/ai-board/extension/index.vue'),
      meta: {
        title: '连接器与助理'
      }
    },
    {
      // 菜单根据别名来跳转
      path: 'market',
      name: 'ecoMarket',
      component: () => import('@/pages/ai-board/market/index.vue'),
      meta: {
        title: '生态市场'
      }
    },
    // TODO 已经下架的页面
    {
      // 菜单根据别名来跳转
      path: 'homepage',
      name: 'homepage',
      component: () => import('@/pages/ai-board/homepage/index.vue'),
      meta: {
        title: '首页'
      }
    },
    {
      path: 'subscribe',
      name: 'subscribe',
      component: () => import('@/pages/ai-board/subscribe/index.vue'),
      meta: {
        title: '订阅'
      }
    }
  ]
}
